export default {
  home: 'Home',
  components: 'Components',
  count_to_page: 'Count-to',
  tables_page: 'Table',
  split_pane_page: 'Split-pane',
  markdown_page: 'Markdown-editor',
  editor_page: 'Rich-Text-Editor',
  icons_page: 'Custom-icon',
  img_cropper_page: 'Image-editor',
  update: 'Update',
  doc: 'Document',
  join_page: 'QQ Group',
  update_table_page: 'Update .CSV',
  update_paste_page: 'Paste Table Data',
  multilevel: 'multilevel',
  directive_page: 'Directive',
  level_1: 'level-1',
  level_2: 'level-2',
  level_2_1: 'level-2-1',
  excel: 'Excel',
  'upload-excel': 'Upload Excel',
  'export-excel': 'Export Excel',
  tools_methods_page: 'Tools Methods',
  drag_list_page: 'Drag-list',
  i18n_page: 'Internationalization',
  modalTitle: 'Modal Title',
  content: 'This is the modal box content.',
  buttonText: 'Show Modal',
  'i18n-tip': 'Note: Only this page is multi-language, other pages do not add language content to the multi-language package.',
  error_store_page: 'Error Collection',
  error_logger_page: 'Error Logger',
  user_manage: 'User',
  account_manage: 'Account Manage',
  role_manage: 'Role Manage',
  monitor: 'Monitor',
  monitor_template: 'Monitor Template',
  monitor_query: 'Monitor Query',
  alarm_metric: 'Alarm Metric',
  settings: 'Settings',
  interface: 'Interface',
  change_password: 'Change Password',
  ops_center: 'OPS Center',
  certificate_manage: 'Certificate Manage',
  server_manage: 'Server Manage',
  script_manage: 'Script Manage',
  cron_manage: 'Cron Manage',
  server_detail: 'Server Detail',
  support_manage: 'Support Manage',
  cron_detail: 'Cron Detail',
  database: 'Database',
  InstanceList: 'InstanceList',
  CategoryList: 'CategoryList',
  ParamList: 'ParamList',
  InstanceDetail: 'InstanceDetail',
  alarm_logs: 'Alarm Logs',
  cmdb: 'CMDB',
  fixed_asset: 'Fixed Asset',
  MySQL: 'MySQL',
  SQLSERVER: 'SQLSERVER',
  MongoDB: 'MongoDB',
  mysqlInstanceDetail: 'mysqlInstanceDetail',
  sqlserverInstanceDetail: 'sqlserverInstanceDetail',
  privateCloud: 'Private Cloud',
  compute: 'Compute',
  server: 'Server',
  image: 'Image',
  keyPairs: 'Key Pairs',
  storage: 'Storage',
  volumes: 'Volumes',
  backups: 'Backups',
  snapshots: 'Snapshots',
  net: 'Net',
  topology: 'Topology',
  network: 'Network',
  route: 'Route',
  securityGroups: 'Security Groups',
  floatingIps: 'Floating Ips',
  image_detail: 'Image Detail',
  flavor: 'Flavor',
  heart_config: 'Heart Config'
}
